<template>
  <section class="coupon-setting">
    <PageTitle
      :title="$t('businessTimeSettings.title')"
      icon="chevron_left"
      style="padding-bottom: 24px"
      hideBtn
      @iconClick="$router.push({ name: 'Parameters' })"
    />
    <AllStoreSettings v-if="useBranch" />
    <ShopBusinessTimeSettings />
    <AllStoreList v-if="useBranch" />
  </section>
</template>

<script>
import { defineComponent, computed } from 'vue'
import ShopBusinessTimeSettings from './ShopBusinessTimeSettings.vue'
import AllStoreSettings from './AllStoreSettings.vue'
import AllStoreList from './AllStoreList.vue'
import { usePermissions } from '@/use/permissions'

export default defineComponent({
  name: 'BusinessTimeSettings',
  components: { ShopBusinessTimeSettings, AllStoreSettings, AllStoreList },
  setup (props) {
    const { checkAction } = usePermissions()
    const useBranch = computed(() => checkAction('planModule.branch.enable'))
    return {
      useBranch,
    }
  },
})
</script>
<style lang="postcss" scoped>
::v-deep .el-select .el-input {
  @apply w-auto
}
ol {
  list-style: demical;
  padding-left: 16px;
}
::v-deep .el-form-item__label, ::v-deep .el-form-item__content {
  color: var(--info);
  line-height: 20.27px;
}

::v-deep .el-radio {
  display: inline-flex;
  align-items: center;
}

::v-deep .el-radio__inner {
  width: 20px;
  height: 20px;
}

::v-deep .el-radio-group .el-radio__inner::after {
  width: 15px;
  height: 15px;
  border-width: 3px;
}
</style>
